import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { TooltipTextCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';

import type { CollectingOutboundListItem } from '~/types/delivery-agency.types';

const getDeliveryAgencyCollectingRequestCandidatesColumnDefs = ({
  currentPage,
  pageSize,
}: {
  currentPage: number;
  pageSize: number;
}) => {
  const columnDefs: ColDef<CollectingOutboundListItem>[] = [
    {
      colId: 'selection',
      headerName: '',
      checkboxSelection: true,
      width: 49,
    },
    {
      colId: 'rowNumber',
      headerName: 'No',
      valueGetter: ({ node }) => (node?.rowIndex ?? 0) + 1 + currentPage * pageSize,
      width: 72,
    },
    {
      field: 'outboundCode',
      headerName: '출고번호',
      width: 160,
    },
    {
      field: 'clientOrderCodes',
      headerName: '판매처 주문번호(원주문)',
      width: 160,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<CollectingOutboundListItem, CollectingOutboundListItem['clientOrderCodes']>) =>
        value?.length ? value.join(', ') : '-',
      cellRenderer: TooltipTextCell,
    },
    {
      field: 'receiverName',
      headerName: '원주문 수령자명',
      width: 120,
    },
    {
      field: 'ordererName',
      headerName: '원주문 주문자명',
      width: 120,
    },
    {
      field: 'productNames',
      headerName: '원주문 상품명',
      width: 248,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<CollectingOutboundListItem, CollectingOutboundListItem['productNames']>) =>
        value?.length ? value.join(', ') : '-',
      cellRenderer: TooltipTextCell,
    },
    {
      field: 'estimatedDeliveryDate',
      headerName: '배송예정일',
      width: 164,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<CollectingOutboundListItem, CollectingOutboundListItem['estimatedDeliveryDate']>) =>
        formatDate(value, DATE_FORMAT.DATE) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCollectingRequestCandidatesColumnDefs;
